import { useState } from 'react';

const galleryImages = [
  {
    src: 'https://storage.readdy-site.link/project_files/c46f7f07-593f-4f17-9a57-3ac86083c18c/8a744d67-edcc-461c-a00f-cff00962dcb2_DJI_0125.jpg?v=75d888a170cc561f6e9c0beb2c51d415',
    alt: 'Aerial view of the Great Barrier Reef near Bedarra Island',
    span: 'col-span-2 row-span-2',
  },
  {
    src: 'https://public.readdy.ai/ai/img_res/9bf524176007ea226bfc0005a932d605.jpg',
    alt: 'Certified diver exploring the outer reef',
    span: 'col-span-1 row-span-1',
  },
  {
    src: 'https://public.readdy.ai/ai/img_res/fa8a91f943cc1f736c8bcb1f70439034.jpg',
    alt: 'Discover Scuba Diving experience with PADI instructor',
    span: 'col-span-1 row-span-1',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=snorkeler%20floating%20above%20vibrant%20Great%20Barrier%20Reef%20coral%20gardens%20Queensland%20Australia%2C%20aerial%20underwater%20view%2C%20tropical%20fish%20and%20sea%20turtles%20visible%20below%20surface%2C%20crystal%20clear%20turquoise%20water%2C%20bright%20sunny%20tropical%20day%2C%20stunning%20reef%20colors%2C%20shallow%20reef%20snorkeling%20experience&width=400&height=280&seq=bedarra-exp-03&orientation=landscape',
    alt: 'Snorkelling above the coral gardens of the Great Barrier Reef',
    span: 'col-span-1 row-span-1',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=MV%20Mahi-Mahi%20dive%20boat%20on%20calm%20tropical%20blue%20ocean%20Queensland%20Australia%2C%20sunny%20day%2C%20white%20vessel%2C%20clear%20sky%2C%20turquoise%20water%2C%20Great%20Barrier%20Reef%20day%20trip%20boat%2C%20professional%20dive%20charter%20vessel%2C%20beautiful%20tropical%20seascape&width=600&height=400&seq=bedarra-gallery-04&orientation=landscape',
    alt: 'MV Mahi-Mahi dive boat on the Great Barrier Reef',
    span: 'col-span-1 row-span-1',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=sea%20turtle%20swimming%20over%20colorful%20coral%20reef%20Great%20Barrier%20Reef%20Queensland%20Australia%2C%20crystal%20clear%20tropical%20water%2C%20vibrant%20coral%20colors%2C%20underwater%20photography%2C%20marine%20wildlife%2C%20stunning%20reef%20ecosystem%2C%20tropical%20fish%20surrounding%20turtle&width=400&height=400&seq=bedarra-gallery-05&orientation=squarish',
    alt: 'Sea turtle on the Great Barrier Reef',
    span: 'col-span-1 row-span-1',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=PADI%20dive%20instructor%20helping%20student%20diver%20on%20boat%20deck%20Mission%20Beach%20Queensland%2C%20sunny%20tropical%20day%2C%20dive%20equipment%20on%20deck%2C%20professional%20dive%20crew%2C%20friendly%20atmosphere%2C%20scuba%20gear%20preparation%2C%20ocean%20background&width=400&height=280&seq=bedarra-gallery-06&orientation=landscape',
    alt: 'PADI dive instructor preparing guests on MV Mahi-Mahi',
    span: 'col-span-1 row-span-1',
  },
];

export default function GallerySection() {
  const [lightbox, setLightbox] = useState<string | null>(null);

  return (
    <section id="gallery" className="w-full bg-white py-24 px-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-xs uppercase tracking-[3px] text-cyan-500 font-semibold mb-4">Gallery</p>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 leading-tight mb-4">
            Life Beneath the Surface
          </h2>
          <p className="text-gray-500 text-base max-w-lg mx-auto font-light leading-relaxed">
            A glimpse of what awaits you on the outer Great Barrier Reef — from Bedarra Island to Beaver Reef and beyond.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 auto-rows-[220px]">
          {galleryImages.map((img, i) => (
            <div
              key={i}
              className={`${img.span} overflow-hidden rounded-2xl cursor-pointer group relative`}
              onClick={() => setLightbox(img.src)}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/80 text-gray-800 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className="ri-zoom-in-line text-lg"></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href="https://wa.me/61455957263?text=Hi!%20I'd%20like%20to%20book%20a%20dive%20trip%20to%20Bedarra%20Island."
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-4 rounded-full bg-gradient-to-r from-orange-500 to-amber-500 text-white font-bold text-sm cursor-pointer hover:scale-105 transition-transform duration-300"
          >
            <i className="ri-ship-2-line w-4 h-4 flex items-center justify-center"></i>
            Book Your Reef Day
          </a>
        </div>
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4 cursor-pointer"
          onClick={() => setLightbox(null)}
        >
          <button
            className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors cursor-pointer"
            onClick={() => setLightbox(null)}
            aria-label="Close"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
          <img
            src={lightbox}
            alt="Gallery preview"
            className="max-w-full max-h-[85vh] rounded-xl object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
}
